import { COMPLIANCE_STATUS } from "../../constants/constant";

interface PilotHoursCardProps {
  rests?: number;
  sevenDays: string;
  fourteenDays: string;
  hours7Style?:string;
  hours14Style?:string;
  restStyle?:string;
}
export default function PilotHoursCard({
  rests,
  sevenDays,
  fourteenDays,
  hours7Style,
  hours14Style,
  restStyle
}: PilotHoursCardProps) {
  return (
    <>
      <div className="grid grid-cols-2 sm:grid-cols-3 gap-y-6 gap-x-6 text-start text-sm">
        <div className="flex flex-col">
          <p className="font-medium text-textColorGray">Rests (days)</p>
          <p 
            className={` ${
            restStyle === COMPLIANCE_STATUS.expired
            ? 'text-red-700'
            : restStyle === COMPLIANCE_STATUS.upcoming || restStyle === COMPLIANCE_STATUS.current
              ? 'text-yellow-500'
              : restStyle === ''||COMPLIANCE_STATUS.compliant
                ? 'text-green'
                : 'text-gray-700'
              }`}
          >{rests}</p>
        </div>
        <div className="flex flex-col">
          <p className="font-medium text-textColorGray">7 Days (hrs)</p>
          <p 
          className={` ${
            hours7Style === COMPLIANCE_STATUS.expired
            ? 'text-red-700'
            : hours7Style === COMPLIANCE_STATUS.upcoming || hours7Style === COMPLIANCE_STATUS.current
              ? 'text-yellow-500'
              : hours7Style === ''||COMPLIANCE_STATUS.compliant
                ? 'text-green'
                : 'text-gray-700'
            }`}
          
          >{sevenDays}</p>
        </div>
        <div className="flex flex-col">
          <p className="font-medium text-textColorGray">14 Days (hrs)</p>
          <p 
           className={` ${
            hours14Style === COMPLIANCE_STATUS.expired
            ? 'text-red-700'
            : hours14Style === COMPLIANCE_STATUS.upcoming || hours14Style === COMPLIANCE_STATUS.current
              ? 'text-yellow-500'
              : hours14Style === ''||COMPLIANCE_STATUS.compliant
                ? 'text-green'
                : 'text-gray-700'
             }`}
          >{fourteenDays}</p>
        </div>
      </div>
    </>
  );
}
